import { render, staticRenderFns } from "./BookingCalendarWeekMobile.vue?vue&type=template&id=318a275d"
import script from "./BookingCalendarWeekMobile.vue?vue&type=script&lang=js"
export * from "./BookingCalendarWeekMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports